export const ANIMATION_STYLE = `
  @keyframes ssFadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes ssFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes ssShimmer {
    0%, 100% { opacity: 0.6; }
    50% { opacity: 1; }
  }
  @keyframes ssDividerSweep {
    0%   { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  @keyframes ssSkeleton {
    0%   { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  .ss-fade-up {
    animation: ssFadeUp 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  }
  .ss-fade-in {
    animation: ssFadeIn 0.6s ease-out backwards;
  }
  .ss-shimmer {
    animation: ssShimmer 2.5s ease-in-out infinite;
  }
  .ss-divider-sweep {
    background: linear-gradient(90deg,
      rgba(124, 58, 237, 0) 0%,
      rgba(124, 58, 237, 0.45) 45%,
      rgba(236, 72, 153, 0.55) 50%,
      rgba(124, 58, 237, 0.45) 55%,
      rgba(124, 58, 237, 0) 100%);
    background-size: 200% 100%;
    animation: ssDividerSweep 6s linear infinite;
  }
  .ss-skeleton {
    background: linear-gradient(90deg,
      rgba(24, 24, 49, 1) 0%,
      rgba(40, 40, 75, 1) 50%,
      rgba(24, 24, 49, 1) 100%);
    background-size: 200% 100%;
    animation: ssSkeleton 1.6s ease-in-out infinite;
  }

  /* Recharts hover effects -- dim siblings, lift the hovered bar/sector. */
  .ss-chart .recharts-bar-rectangle path,
  .ss-chart .recharts-pie-sector path {
    transition: opacity 180ms ease, filter 180ms ease, transform 180ms ease;
    transform-box: fill-box;
    transform-origin: center;
  }
  .ss-chart .recharts-bar-rectangles:hover .recharts-bar-rectangle path,
  .ss-chart .recharts-pie:hover .recharts-pie-sector path {
    opacity: 0.4;
  }
  .ss-chart .recharts-bar-rectangles .recharts-bar-rectangle:hover path {
    opacity: 1;
    filter: brightness(1.25) drop-shadow(0 0 6px currentColor);
  }
  .ss-chart .recharts-pie .recharts-pie-sector:hover path {
    opacity: 1;
    transform: scale(1.04);
    filter: brightness(1.2) drop-shadow(0 0 8px currentColor);
  }
`;
